import React from "react";

import { WarningMessagePropType } from "@models/utils/warningMessage.model";

const WarningMessageBox: React.FC<WarningMessagePropType> = ({
  className,
  message,
}) => {
  return (
    <div
      className={`fg-status-msg-box warning-msg ${className ?? ""}`}
      data-testid="warning-msg-box"
    >
      <span>{message}</span>
    </div>
  );
};

export default WarningMessageBox;
